module["exports"] = ["Hr.", "Fr.", "Dr.", "Prof. Dr."];